export default __webpack_public_path__ + "static/media/FuelYourWanderLust.34e0d286.JPG";